import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { UseCaseFormData } from "../types/use-case.types"

import { useCasesQueryKeys } from "./use-cases-query-keys"
import { aiSalesPitch } from "../api/use-cases-api"

export function useAiSalesPitch() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      useCaseData,
      useCaseId,
    }: {
      useCaseData: Partial<UseCaseFormData>
      useCaseId?: string
    }) => aiSalesPitch(useCaseData, useCaseId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: useCasesQueryKeys.list() })
    },
  })
}
